module.exports = __webpack_public_path__ + "static/img/heweogoLogo.4c30317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopRegister/heweogoLogo.png
// module id = lCS6
// module chunks = 51